/**
 * @fileoverview Agent definition for distill-changes-v1.
 *
 * Takes the three-hat editorial feedback produced by story-feedback-v1 and
 * distills it into a succinct but comprehensive, prioritized list of
 * high-level structural changes for the full story.
 *
 * The output is designed to feed story-modifier-v1 directly — its
 * `changeRequest` string is formatted so it can be used verbatim as that
 * agent's input. For now there is no automatic hand-off; the two agents are
 * coupled only by this contract.
 *
 * @category narrative.story.analysis
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'distill-changes-v1',
  kind: 'primitive',
  name: 'Distill Recommended Changes',
  description: 'Distills multi-hat story feedback into a succinct, prioritized list of high-level structural changes for the whole story. Output is designed to be consumed by story-modifier-v1.',
  category: 'structure',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-04',
    lastUpdated: '2026-04',
    taxonomyPath: 'narrative.story.analysis',
    usedBy: [
      'primitives/use-distill-changes-v1.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'story-feedback-v1',
      'story-modifier-v1',
    ],
  },
};
